import React, { useEffect, useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import { IconButton, Flex, HStack, FlexProps, Image } from '@chakra-ui/react';
import {
  api,
  setGlobalDate,
  setGlobalPeriod,
  useAppDispatch,
} from '@spartalabs/pdc-core';
import logoSvg from 'assets/svg/logo.svg';
import DateRangeComp from 'components/Calendar';
import SegmentedPicker from 'components/SegmentedPicker';
import { addMonths } from 'date-fns';
import { useDateSelect } from 'hooks/useDateSelect';
import { useSegmentedPicker } from 'hooks/useSegmentedPicker';
import { isHeaderDateSelectShown } from 'utils/functions';
import { HeaderMenu } from '../Menu';

interface HeaderProps extends FlexProps {
  onOpen: () => void;
  path: string;
}

export const Header = ({ onOpen, path, ...rest }: HeaderProps) => {
  const dispatch = useAppDispatch();

  const [pickedPeriod, setPickedPeriod] = useState('Mês');
  const { onSegmentedPickerChange } = useSegmentedPicker(setPickedPeriod);
  const [dateRange, setDateRange] = useState<DateProps[]>([
    {
      startDate: addMonths(new Date(), -12),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const { onDateRangeChange } = useDateSelect(setDateRange);

  useEffect(() => {
    dispatch(api.util.resetApiState());
  }, []);

  useEffect(() => {
    const setGlobalDateFunc = () => {
      dispatch(setGlobalPeriod(pickedPeriod));
      dispatch(setGlobalDate(dateRange));
    };

    setGlobalDateFunc();
  }, [dateRange, pickedPeriod]);

  return (
    <Flex
      zIndex={9}
      w="100%"
      position="fixed"
      ml={{ base: 0, xl: 0 }}
      px={4}
      height="60px"
      alignItems="center"
      bg="button"
      justifyContent="space-between"
      {...rest}
    >
      <IconButton
        data-cy="menu"
        color="white"
        display={{ base: 'flex', xl: 'none' }}
        onClick={onOpen}
        aria-label="open menu"
        icon={<FiMenu size="18px" />}
      />

      <Image
        display={{ base: 'flex', xl: 'none' }}
        pl="8px"
        src={logoSvg}
        h="40px"
      />

      <HStack display="flex" spacing={6} ml={{ base: '0', xl: 'auto' }}>
        <DateRangeComp
          dateName="header"
          display={isHeaderDateSelectShown(path) ? 'flex' : 'none'}
          type={pickedPeriod}
          startDate={dateRange}
          ref={onDateRangeChange}
          isOnHeader
          // minW="186"
        />
        <SegmentedPicker
          pickerName="header"
          display={isHeaderDateSelectShown(path) ? 'flex' : 'none'}
          firstSelectedLabel={pickedPeriod}
          ref={onSegmentedPickerChange}
          labels={['Dia', 'Mês']}
        />

        <HeaderMenu />
      </HStack>
    </Flex>
  );
};
